module.exports = __webpack_public_path__ + "static/img/medical_device_license.1172509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medical_device_license.png
// module id = 3/Hc
// module chunks = 1